import { FC, ForwardRefExoticComponent } from "react";
import { C8FieldType } from "src/c8-platform/type/value";
import { BooleanComponentWrapper } from "./boolean/index";
import { DoubleComponentWrapper, IntegerComponentWrapper } from "./number/index";
import { Ref } from "./ref/Ref";
import { Enum } from "./enum/Enum";
import { EnumList } from "./enum/EnumList";
import { EnumSet } from "./enum/EnumSet";
import { RefContainer } from "./ref/RefContainer";
import { StringComponentWrapper } from "./string/index";
import { TimeComponentWrapper } from "./time/index";

// TODO: types

// One way is to union the types of each renderer
// type RendererProps = CheckboxComponentProps | Omit<NumberComponentProps, "nodeType"> | RefProps | StringComponentProps | ExtendedDateTimePickerProps;

// The other way is to get the intersection of the common base types of the form field
// type RendererProps = IFormFieldTransientBase & IFormFieldBase;

export type RendererProps = any;
export type Renderer = FC<RendererProps> | ForwardRefExoticComponent<RendererProps> | undefined;

type RendererRegistry = Record<C8FieldType, Renderer>;

const registry: RendererRegistry = {
	// TODO: extract a common type that FormField components extend and is common to all renderers
	boolean: BooleanComponentWrapper,
	integer: IntegerComponentWrapper,
	double: DoubleComponentWrapper,
	string: StringComponentWrapper,
	ref: Ref,
	enum: Enum,
	enumlist: EnumList,
	enumset: EnumSet,
	reflist: RefContainer,
	refset: RefContainer,
	refvector: RefContainer,
	time: TimeComponentWrapper,
} as RendererRegistry;

/** get renderer for given value type */
const getRenderer = (valueType: C8FieldType): Renderer => {
	// use the string renderer if the value type is not supported
	return registry[valueType] || StringComponentWrapper;
};

/** register renderer for given value type */
const registerRenderer = (valueType: C8FieldType, renderer: Renderer): void => {
	registry[valueType] = renderer;
};

export { getRenderer, registerRenderer };
